import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TrpcService } from 'src/app/services/trpc/trpc.service';

@Component({
  selector: 'app-view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrl: './view-invoice.component.scss'
})
export class ViewInvoiceComponent {

  invoiceNumber: string = '';
  invoiceInProgress: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService
  ) { }

  async viewInvoice() {

    this.messageService.clear();

    if(this.invoiceNumber.trim() == "") {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please enter invoice number.",
      });
      return;
    }

    try {
      this.invoiceInProgress = true;
      let invoiceResult = await this.trpcService.trpc.invoice.viewInvoice.query({ invoice: Number(this.invoiceNumber) });

      if (invoiceResult) {
        const byteCharacters = atob(invoiceResult.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: "application/pdf" });
        window.open(window.URL.createObjectURL(blob), "_blank", "top=100,left=100,width=600,height=500,status=yes,resizable=yes,scrollbars=yes,location=no");
        
        this.invoiceNumber = '';

      }

    } catch (error: any) {
      this.messageService.add({
        key: 'view-invoice-result',
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to download invoice.",
      });
    } finally {
      this.invoiceInProgress = false;
    }
  }

}
